// extracted by mini-css-extract-plugin
export default {"containerText":"Paragraph_containerText__3iRyv"};